/**
 * Exhaustiveness guard for discriminated unions and provider switches.
 *
 * Place at the `default:` arm of a `switch` (or the final `else`) over a closed
 * union. If every case is handled, `value` narrows to `never` and the call
 * type-checks. Adding a new union member without a matching case makes `value`
 * no longer `never`, so this call becomes a **compile error** — the missing
 * branch is caught at build time, not in production.
 *
 * The thrown message stringifies `value` only; for object unions this yields
 * `[object Object]` (no field enumeration), so it is safe to log even when the
 * union carries PII-bearing variants.
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled case: ${String(value)}`);
}
